export default {
  name: "POIStep",
  props: ["step", "position", "title"]
};
